/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import Sync from "../../../sync/sync";


export class SyncContextType {
    constructor (public sync: Sync) {}
}

export const SyncContext = createContext<SyncContextType | undefined>(undefined);

export const useSyncContext = (): SyncContextType => {
    const context = useContext(SyncContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the SyncContext");
    }
    return context;
};